export default "__VITE_ASSET__Na31yDgy__"